/* StorageOZ fridge planner. Scoped refinement 2026-10-22; existing cart, no bundle discount. */
(() => {
  function init(root) {
    if (root.dataset.plannerReady) return;
    root.dataset.plannerReady = 'true';
    const cards = [...root.querySelectorAll('[data-fridge-item]')].filter(c => c.querySelector('[data-planner-check]'));
    const buttons = [...root.querySelectorAll('[data-planner-add]')];
    const messages = [...root.querySelectorAll('[data-planner-message]')];
    const cartLinks = [...root.querySelectorAll('[data-planner-cart]')];
    const sticky = root.querySelector('[data-planner-sticky]');
    const comparison = root.querySelector('[data-planner-comparison]');
    if (!buttons.length || !messages.length) return;
    const money = n => new Intl.NumberFormat(root.dataset.locale || 'en-AU', {style:'currency',currency:root.dataset.currency || 'AUD'}).format(n / 100);
    let busy = false, reviewRequired = false;
    const setMessage = text => messages.forEach(el => {el.textContent = text;});
    const disableButtons = disabled => buttons.forEach(el => {el.disabled = disabled;});
    const setBusy = value => {
      busy = value;
      cards.forEach(c => c.querySelectorAll('[data-planner-check], [data-planner-variant], [data-planner-quantity]').forEach(el => {el.disabled = value;}));
      buttons.forEach(el => {el.textContent = value ? 'Adding…' : (el.dataset.plannerLabel || 'Add selected items to cart');});
      disableButtons(true);
    };
    function selection() {
      return cards.filter(c => c.querySelector('[data-planner-check]').checked).map(c => {
        const option = c.querySelector('[data-planner-variant]').selectedOptions[0];
        const quantity = Number(c.querySelector('[data-planner-quantity]').value);
        if (!option || !Number.isInteger(quantity) || quantity < 1 || quantity > Number(option.dataset.stock)) throw new Error('Check each selected pack quantity against its available stock.');
        return {id:Number(option.value),quantity,price:Number(option.dataset.price),stock:Number(option.dataset.stock),productUrl:option.dataset.productUrl};
      });
    }
    function update() {
      cards.forEach(c => {
        const option = c.querySelector('[data-planner-variant]').selectedOptions[0];
        if (!option) return;
        c.querySelector('[data-planner-quantity]').max = option.dataset.stock;
        c.querySelector('[data-option-note]').textContent = 'Selected pack: ' + option.textContent.trim();
        c.querySelectorAll('.soz-ft-product-photo, h3 a, .soz-ft-product-link').forEach(link => {link.href = option.dataset.productUrl;});
        const price = c.querySelector('.soz-ft-price');
        if (price) price.textContent = money(Number(option.dataset.price));
      });
      const hasSelection = cards.some(c => c.querySelector('[data-planner-check]').checked);
      root.dataset.plannerHasSelection = String(hasSelection);
      if (sticky) sticky.hidden = !hasSelection;
      try {
        const items = selection();
        root.querySelectorAll('[data-planner-count]').forEach(el => {el.textContent = items.reduce((n,i) => n+i.quantity,0);});
        root.querySelectorAll('[data-planner-total]').forEach(el => {el.textContent = money(items.reduce((n,i) => n+i.price*i.quantity,0));});
        disableButtons(busy || reviewRequired || items.length === 0);
        if (!busy && !reviewRequired) setMessage('');
      } catch(e) {
        disableButtons(true);
        root.querySelectorAll('[data-planner-count], [data-planner-total]').forEach(el => {el.textContent = '—';});
        setMessage(e.message);
      }
    }
    root.querySelectorAll('[data-planner-controls]').forEach(el => {el.hidden = false;});
    // No-JS visitors retain the complete open table. Mobile JS users can expand it on demand.
    if (comparison && window.matchMedia('(max-width: 649px)').matches) comparison.open = false;
    root.addEventListener('change', update);
    root.addEventListener('input', e => {if(e.target.matches('[data-planner-quantity]')) update();});
    async function addSelected() {
      if (busy || reviewRequired) return;
      let items;
      try {items = selection();} catch(e) {setMessage(e.message);return;}
      if (!items.length) return;
      setBusy(true);setMessage('');cartLinks.forEach(el => {el.hidden = true;});
      let posted = false;
      try {
        const cartResponse = await fetch(root.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error('Could not check your cart. Please try again.');
        const cart = await cartResponse.json();
        for (const item of items) {
          const r = await fetch(new URL(item.productUrl.split('?')[0]+'.js', location.origin), {headers:{Accept:'application/json'}});
          if (!r.ok) throw new Error('Could not recheck an item. Review its product page before adding.');
          const product = await r.json(), variant = product.variants.find(v => v.id === item.id);
          const existing = cart.items.filter(i => i.variant_id === item.id).reduce((n,i) => n+i.quantity,0);
          if (!variant?.available || existing+item.quantity > item.stock) throw new Error('A selected quantity is unavailable or already partly in your cart. Review quantities and current availability.');
          if (variant.price !== item.price) throw new Error('An item price has changed. Refresh this page to review the current subtotal.');
        }
        posted = true;
        const r = await fetch(root.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items.map(({id,quantity}) => ({id,quantity}))})});
        const data = await r.json();
        if (!r.ok) throw new Error((typeof data.description === 'string' ? data.description : 'Some items could not be added.')+' Check your cart before trying again.');
        location.assign(root.dataset.cartUrl);
      } catch(e) {
        // An ambiguous POST must never become a silent duplicate via the second CTA or an input change.
        reviewRequired = posted;
        setMessage(posted ? e.message+' An item may already have been added. Review your cart before refreshing this page.' : e.message);
        cartLinks.forEach(el => {el.hidden = false;});
      } finally {setBusy(false);}
    }
    buttons.forEach(button => button.addEventListener('click', addSelected));
    update();
  }
  function start(){document.querySelectorAll('[data-fridge-planner]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();
